import type { ReactNode } from 'react'

import styles from './AudioHeroPlayback.module.css'

type TAudioHeroPlaybackProps = {
    waveformSlot: ReactNode
    timeSlot: ReactNode
    /** Large round play/pause control, left of the waveform (desktop only). */
    playButtonSlot: ReactNode
    /** Waveform-comment marker overlay (desktop). */
    overlaySlot?: ReactNode
}

export const AudioHeroPlayback = ({
    waveformSlot,
    timeSlot,
    playButtonSlot,
    overlaySlot,
}: TAudioHeroPlaybackProps) => (
    <div className={styles.playback}>
        <div className={styles.time}>{timeSlot}</div>
        <div className={styles.row}>
            <div className={styles.sidePlay}>{playButtonSlot}</div>
            <div className={styles.waveform}>
                {waveformSlot}
                {overlaySlot ? <div className={styles.overlay}>{overlaySlot}</div> : null}
            </div>
        </div>
    </div>
)
